import { sha256Hex } from "./browser-crypto";

const encoder = new TextEncoder();

function hex(bytes: ArrayBuffer): string {
  return [...new Uint8Array(bytes)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function randomCode(): string {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return String(100000 + (values[0] % 900000));
}

export function randomSecret(): string {
  const values = new Uint8Array(32);
  crypto.getRandomValues(values);
  return btoa(String.fromCharCode(...values)).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}

export async function hashSecret(value: string, salt = ""): Promise<string> {
  return sha256Hex(encoder.encode(`${salt}:${value}`));
}

export function newSalt(): string {
  const values = new Uint8Array(16);
  crypto.getRandomValues(values);
  return hex(values.buffer);
}
